import { FunctionComponent } from 'react';
import Profile from 'components/profile/Profile';
import { Redirect, usePathParam } from 'react-resource-router';
import { ErrorBoundary } from 'react-error-boundary';
import Fallback from 'components/common/fallback/Fallback';
import { logBoundaryError } from 'services/logger';
import useValidateProfileIdPath from 'utils/useValidateUsernamePath';

const ProfilePage: FunctionComponent = () => {
  const [pathProfileId] = usePathParam('pathProfileId');
  const isValid = useValidateProfileIdPath();

  return (
    <>
      {isValid ? (
        <div>
          <ErrorBoundary
            FallbackComponent={Fallback}
            onError={logBoundaryError}
          >
            <Profile internalId={pathProfileId as string} />
          </ErrorBoundary>
        </div>
      ) : (
        <Redirect to="/error/invalid_path" />
      )}
    </>
  );
};

export default ProfilePage;
